<template>
  <div class="catalog">
    <cata-item
      v-for="(item, index) in catalog"
      :cata="item"
      :key="index"
    ></cata-item>
  </div>
</template>

<script>
import cataItem from './cata-item.vue'
import Bus from './bus'
export default {
  components: { cataItem },
  props: ['catalog'],
  data() {
    return {
      activeCata: null
    }
  },
  provide() {
    return {
      catalog: this
    }
  },
  mounted() {
    Bus.$on('cata-click', cata => {
      this.activeCata = cata
      this.$emit('cataSelected', cata)
    })
  },
  destroyed() {
    Bus.$off('cata-click')
  },
  methods: {
    setActiveCata(cata) {
      this.activeCata = cata
      this.$emit('cataSelected', cata) 
    }
  },
}
</script>

<style lang="scss" scoped>
.catalog {
  width: 100%;
  margin-top: 20px;
}
</style>